import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, BoxTheme, Icon, IconName, IconSize, Text } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetSpecialtyType } from '../../redux/product/selectors/ProductSelector';
import { Tooltip } from '@yonderland/andes-react';
const ProductSpecialtyMessageContainer = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const specialtyType = useSelector(makeGetSpecialtyType());
    if (!specialtyType) {
        return null;
    }
    return (_jsx(Box, { mobile: { spacing: { marginTop: 2, padding: 2 }, theme: BoxTheme.TERTIARY }, children: _jsxs(Text, { color: "B500", children: [t(`${I18N_NAMESPACES.product}:product.specialty.message`, {
                    specialty_type: t(`${I18N_NAMESPACES.product}:product.specialty.type.${specialtyType}`),
                }), ' ', _jsx(Tooltip, { text: t(`${I18N_NAMESPACES.product}:product.specialty.tooltip.${specialtyType}`), hasCloseBtn: false, children: _jsx(Icon, { size: IconSize.MINOR, name: IconName.INFORMATION_OUTLINE }) })] }) }));
};
export default ProductSpecialtyMessageContainer;
